import '../../styles/globals.css'

function Plans(){
    return (
        <section className="plans">
            <div className="container">
                <h2 className="section-title">Nossos Planos de Saúde</h2>
                <div className="plans-grid">
                    <div className="plan-card">
                        <h3 className="plan-name">Plano Básico</h3>
                        <div className="plan-price">R$ 128,83<span>/mês</span></div>
                        <ul className="plan-features">
                            <li>Consultas médicas</li>
                            <li>Exames laboratoriais</li>
                            <li>Atendimento de urgência</li>
                            <li>Descontos em medicamentos</li>
                            <li>Telemedicina 24h</li>
                        </ul>
                        <a href="#form" className="btn">Contratar</a>
                    </div>
                    <div className="plan-card popular">
                        <div className="popular-badge">MAIS POPULAR</div>
                        <h3 className="plan-name">Plano Familiar</h3>
                        <div className="plan-price">R$ 467,31<span>/mês</span></div>
                        <ul className="plan-features">
                            <li>Todos os benefícios do Básico</li>
                            <li>Cobertura para toda família</li>
                            <li>Odontologia inclusa</li>
                            <li>Descontos em medicamentos</li>
                            <li>Telemedicina 24h</li>
                        </ul>
                        <a href="#form" className="btn">Contratar</a>
                    </div>
                    <div className="plan-card">
                        <h3 className="plan-name">Plano Empresarial</h3>
                        <div className="plan-price">R$ 151,15<span>/mês</span></div>
                        <ul className="plan-features">
                            <li>Todos os benefícios do Básico</li>
                            <li>Consultas com especialistas</li>
                            <li>Sem coparticipação exceto terapias</li>
                            <li>Procedimentos de média complexidade</li>
                            <li>Telemedicina 24h</li>
                        </ul>
                        <a href="#form" className="btn">Contratar</a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Plans;